<script>
	import MaskInput from "svelte-input-mask";
	export let value = ""
	export let cantidad = 8

	let mask = "000000000000000000000000000000".substr(0,cantidad);
	const handleChange = e => {
	  	value = e.detail.inputState.unmaskedValue;
	};

</script>

<MaskInput {...$$props} alwaysShowMask maskChar="_" {mask} on:change={handleChange} />
